<div class="questions-container">
  <div 
    *ngFor="let question of questions; let i = index" 
    class="question-container"
  >
    <dx-form #dxFormRef
      [formData]="answers[i]"
      [showColonAfterLabel]="false"
    >
      <dxi-item itemType="group">
        <dxo-col-count-by-screen 
          [xs]="1" 
          [sm]="3" 
          [md]="3" 
          [lg]="4"
        ></dxo-col-count-by-screen>

        <dxi-item [colSpan]="2" cssClass="question-item">
          <ng-template dxTemplate>
            <div class="question-text">
              {{ question.question }} <span *ngIf="question.isRequired" class="required">*</span>
            </div>
          </ng-template>
        </dxi-item>

        @if(question.type === participationTypes.YesNo) {
          <dxi-item
            dataField="yesNoAnswer"
            editorType="dxSelectBox"
            [colSpan]="2"
            [label]="{ visible: false }"
            [editorOptions]="{
              items: yesNoOptions,
              displayExpr: 'label',
              valueExpr: 'value',
              placeholder: ('TRAINING-QUESTIONNAIRE.ANSWER.SELECT-YES-NO' | translate),
            }"
          >
            <dxi-validation-rule
              *ngIf="question.isRequired"
              type="custom"
              [validationCallback]="isYesNoSelected"
              [message]="'VALIDATIONS.ANSWER-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>
        }  @else if(question.type === participationTypes.FreeText) {
          <dxi-item
            dataField="freeTextAnswer"
            editorType="dxTextBox"
            [colSpan]="2"
            [label]="{ visible: false }"
            [editorOptions]="{
              placeholder: ('TRAINING-QUESTIONNAIRE.ANSWER.TYPE-YOUR-ANSWER' | translate)
            }"
          >
            <dxi-validation-rule
              *ngIf="question.isRequired"
              type="required"
              [message]="'VALIDATIONS.ANSWER-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>
        } @else if(question.type === participationTypes.SingleSelect) {
          <dxi-item
            dataField="selectedOptionIds"
            editorType="dxSelectBox"
            [colSpan]="2"
            [editorOptions]="{
              items: question.options ?? [],
              displayExpr: 'value',
              valueExpr: 'id',
              placeholder: ('TRAINING-QUESTIONNAIRE.ANSWER.SELECT-OPTION' | translate)
            }"
            [label]="{ visible: false }"
          >
            <dxi-validation-rule
              *ngIf="question.isRequired"
              type="required"
              [message]="'VALIDATIONS.ANSWER-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>
        } @else if(question.type === participationTypes.MultiSelect) {
          <dxi-item 
            [label]="{ visible: false }"
            [colSpan]="2"
          >
            <div *dxTemplate>
              <dx-drop-down-box
                [value]="answers[i].selectedOptionIds"
                valueExpr="id"
                displayExpr="value"
                [dataSource]="question.options"
                labelMode="floating"
                stylingMode="outlined"
                [placeholder]="'TRAINING-QUESTIONNAIRE.ANSWER.SELECT-OPTIONS' | translate"
              >
                <dx-validator validationGroup="customFields">
                  <dxi-validation-rule
                    *ngIf="question.isRequired"
                    type="required"
                    [message]="'VALIDATIONS.ANSWER-REQUIRED' | translate"
                  ></dxi-validation-rule>
                </dx-validator>
                <div *dxTemplate="let data of 'content'">
                  <dx-tree-view
                    [searchEnabled]="true"
                    [dataSource]="question.options"
                    dataStructure="plain"
                    keyExpr="id"
                    selectionMode="multiple"
                    showCheckBoxesMode="normal"
                    [selectNodesRecursive]="false"
                    displayExpr="value"
                    [selectByClick]="true"
                    (onItemSelectionChanged)="onOptionsSelected($event, answers[i])"
                  >
                  </dx-tree-view>
                </div>
              </dx-drop-down-box>
            </div>
          </dxi-item>
        } @else if(question.type === participationTypes.AdditionalPersons) {
          <dxi-item
            dataField="additionalParticipantsCount"
            editorType="dxSelectBox"
            [colSpan]="2"
            [label]="{ visible: false }"
            [editorOptions]="additionalPersonsEditorOptions[i]"
          >
            <dxi-validation-rule
              *ngIf="question.isRequired"
              type="required"
              [message]="'VALIDATIONS.ANSWER-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>

          <dxi-item 
            *ngIf="answers[i].additionalParticipants && answers[i].additionalParticipants?.length"
            itemType="group" [colSpan]="4"
            cssClass="participant-group"
          >
            <dxi-item 
              *ngFor="let participant of answers[i].additionalParticipants; let j = index"
              itemType="group" [colSpan]="4" 
            >
              <dxo-col-count-by-screen 
                [xs]="2" 
                [sm]="2" 
                [md]="4" 
                [lg]="4"
              ></dxo-col-count-by-screen>
              <dxi-item 
                [colSpan]="2"
                [dataField]="'additionalParticipants.' + j + '.firstName'"
                editorType="dxTextBox"
                [label]="{ visible: false }"
                [editorOptions]="{
                  placeholder: ('COMMON.FIELDS.FIRST-NAME' | translate)
                }"
              >
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.FIRST-NAME-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item 
                [colSpan]="2"
                [dataField]="'additionalParticipants.' + j + '.lastName'"
                editorType="dxTextBox"
                [label]="{ visible: false }"
                [editorOptions]="{
                  placeholder: ('COMMON.FIELDS.LAST-NAME' | translate)
                }"
              >
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.LAST-NAME-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        } @else if(question.type === participationTypes.HotelBooking) {
          <dxi-item
            dataField="yesNoAnswer"
            editorType="dxSelectBox"
            [colSpan]="2"
            [label]="{ visible: false }"
            [editorOptions]="hotelBookingEditorOptions[i]"
          >
            <dxi-validation-rule
              *ngIf="question.isRequired"
              type="custom"
              [validationCallback]="isYesNoSelected"
              [message]="'VALIDATIONS.ANSWER-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>

          <dxi-item 
            *ngIf="showHotelDatesSelection" 
            [colSpan]="4"
          >
            <app-date-selection
              [startDateLabel]="'TRAINING-QUESTIONNAIRE.ANSWER.CHECK-IN-DATE' | translate"
              [endDateLabel]="'TRAINING-QUESTIONNAIRE.ANSWER.CHECK-OUT-DATE' | translate"
              [(startDate)]="answers[i].startHotelDate"
              [(endDate)]="answers[i].endHotelDate"
              [minStartDate]="question.startHotelDate"
              [maxEndDate]="question.endHotelDate"
              [preventSameDay]="true"
            ></app-date-selection>
          </dxi-item>
        }
      </dxi-item> 
    </dx-form>
  </div>
</div>